import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate/dist/vee-validate.minimal'
import { Rules } from 'vee-validate'
import de from 'vee-validate/dist/locale/de'
import fr from 'vee-validate/dist/locale/fr'
import i18n from './i18n'

// add used rules as suggested in:
// https://github.com/baianat/vee-validate/releases/tag/2.0.0-rc.15
Validator.extend('required', Rules.required)
Validator.extend('regex', Rules.regex)
Validator.extend('alpha_num', Rules.alpha_num)
Validator.extend('email', Rules.email)
Validator.extend('digits', Rules.digits)
Validator.extend('min', Rules.min)
Validator.extend('between', Rules.between)
Validator.extend('min_value', Rules.min_value)
Validator.extend('max_value', Rules.max_value)
Validator.extend('decimal', Rules.decimal)
Validator.extend('numeric', Rules.numeric)
Validator.extend('date_format', Rules.date_format)
Validator.extend('date_between', Rules.date_between)
Validator.extend('before', Rules.before)
Validator.extend('after', Rules.after)

const mergeDictionaries = (standard, custom) => ({
  ...standard,
  ...custom,
  messages: {
    ...standard.messages,
    ...custom.messages,
  },
})
/*
  Vee-Validate configuration
  https://vee-validate.logaretm.com/v2/guide/localization.html#using-the-dictionary-api
*/
const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 200,
  i18nRootKey: 'validation',
  i18n,
  dictionary: {
    'de-DE': mergeDictionaries(de, i18n.messages['de-DE'].validation),
    'fr-FR': mergeDictionaries(fr, i18n.messages['fr-FR'].validation),
  },
  strict: true,
  enableAutoClasses: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty', // control has been interacted with
  },
}

Vue.use(VeeValidate, config)
